jQuery(document).ready(function($) {
  var overlay = {
    overlay: $('.js-overlay'),
    closeButton: $('.js-overlay-close'),
    close: function() {
      this.overlay.removeClass('is-open');
    },
    open: function(modalID) {
      var currentOverlay = $('.js-overlay[data-overlay="' + modalID + '"]');
      this.overlay.removeClass('is-open');
      currentOverlay.addClass('is-open');
    },
    handleOpen: function() {
      var overlayID = this.overlay.data('overlay');
      var currentOverlay = $('.js-overlay[data-overlay="' + overlayID + '"]');

      // Open the overlay if no cookie is set
      if(Cookies.get(overlayID) == undefined) {
        this.open(overlayID);
      }

      // Only set the cookie once the overlay has been closed
      currentOverlay.find(overlay.closeButton).click(function() {
        Cookies.set(overlayID, { expires: 14 });
      });
    },
    init: function() {
      var self = this;
      this.handleOpen();

      this.closeButton.click(function(e) {
        self.close();
        e.preventDefault();
      });
    }
  };

  overlay.init();
});